interface Props {
  graduated: number;
  total: number;
  durationMin: number;
  mapNumber: number;
  onNext: () => void;
}

export function SaturationBanner({
  graduated,
  total,
  durationMin,
  mapNumber,
  onNext,
}: Props) {
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-12 z-20 flex items-center justify-center">
      <div
        className="border-rule pointer-events-auto flex items-center gap-6 border px-6 py-3"
        style={{ background: "var(--paper)" }}
      >
        <div className="n5-marginalia" style={{ letterSpacing: "0.18em" }}>
          map complete
        </div>
        <div className="n5-marginalia" style={{ letterSpacing: "0.06em" }}>
          № {mapNumber.toString().padStart(2, "0")} ·{" "}
          {durationMin > 0 ? `${durationMin}m` : "—"} · {graduated} / {total}{" "}
          graduated
        </div>
        <button
          type="button"
          className="n5-btn"
          data-variant="known"
          onClick={onNext}
        >
          Draw a new map →
        </button>
      </div>
    </div>
  );
}
